<template>
	<div id="navbar-stick" class="sticky-top shadow">
		<div class="container">
			<nav class="navbar navbar-expand-lg navbar-light">
				<link-to :to="{name: 'inicio'}" a-class="navbar-brand">
					<img height="50"
					     class="d-none d-xl-inline-block d-lg-inline-block d-md-none d-sm-none align-top m-0 p-0" alt=""
					     title=""
					     src="/assets/images/nav-logo.png">
					
					<img height="50"
					     class="d-inline-block d-xl-none d-lg-none d-md-inline-block d-sm-inline-block align-top m-0 p-0"
					     alt="" title=""
					     src="/assets/images/nav-logo-sm.png">
					
					<img height="50" class="d-inline-block align-top m-0 p-0" alt="" title=""
					     src="/assets/images/logo-menu-uaysen-contigo.png">
				</link-to>
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main-menu"
				        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div id="main-menu" class="collapse navbar-collapse">
					<ul class="navbar-nav navbar-nav-scroll ms-auto">
						<li class="nav-item"
						    v-for="item in MenuItems">
							<link-to :to="item" a-class="nav-link text-uppercase my-2"
							         @click="collapseMenu">
								{{ item.meta.title }}
							</link-to>
						</li>
						<li class="nav-item">
							<a href="#"
							   @click.prevent.stop="doScrolling('#contacto')"
							   class="nav-link text-uppercase my-2">
								Contacto
							</a>
						</li>
					</ul>
				</div>
			</nav>
		</div>
	</div>

</template>
<script>

import {MainMenu} from "../routes";

export default {
	name: "main-menu",
	methods: {
		collapseMenu() {
			let myCollapse = document.getElementById('main-menu')
			let bsCollapse = new bootstrap.Collapse(myCollapse, {toggle: false});
			bsCollapse.hide();
		},
		doScrolling(element, duration = 300) {
			let startingY = window.pageYOffset
			let elementY = window.pageYOffset + document.querySelector(element).getBoundingClientRect().top;
			let targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
			let diff = targetY - startingY
			let easing = function (t) {
				return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
			}
			if (!diff) {
				return
			}
			let start
			let step = function (timestamp) {
				if (!start) {
					start = timestamp
				}
				let time = timestamp - start
				let percent = Math.min(time / duration, 1)
				percent = easing(percent)
				window.scrollTo(0, startingY + diff * percent)
				if (time < duration) {
					window.requestAnimationFrame(step);
				}
			}
			window.requestAnimationFrame(step);
			this.collapseMenu();
		}
		
	},
	computed: {
		MenuItems() {
			return MainMenu;
		}
	}
}
</script>